module.exports = __webpack_public_path__ + "img/1529454974.b4e53222.jpg";